<tt-page *ngIf="!!menu">
    <div *ngIf="'mobile' | mediaQuery">
        <tt-card class="col-xs-12 p-5">
            <tt-tabs [(ttSelectedId)]="selectedBgPohTop">
                <tt-tab ttId="D" ttLabel="this"></tt-tab>
                <tt-tab ttId="INFO" ttLabel="orderinfo"></tt-tab>
                <tt-tab ttId="OL" ttLabel="orderlines"></tt-tab>
            </tt-tabs>

            <tt-button-goto [hidden]="selectedBgPohTop !== 'D'" [ttText]="'orderlinestatus_rfidconnect_this'" [ttGoto]="'rfidconnect'" [ttGotoParms]="{ argtype: 'poh_keyno_top', argvalue: pohKeynoTop }"></tt-button-goto>
            <tt-button-goto [hidden]="selectedBgPohTop !== 'OL'" [ttText]="'orderlinestatus_rfidconnect'" [ttGoto]="'rfidconnect'" [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: menu.order_internal_no }"></tt-button-goto>

            <div [hidden]="selectedBgPohTop !== 'INFO'">
                <ng-container *ngTemplateOutlet="orderInfo"></ng-container>
            </div>
        </tt-card>

        <tt-list [hidden]="selectedBgPohTop !== 'D'" class="col-xs-12 p-5" [ttData]="itemsListPohTops"></tt-list>
        <tt-list [hidden]="selectedBgPohTop !== 'OL'" class="col-xs-12 p-5" [ttData]="itemsListStatuses"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="pohkeynotopstatus_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="20">
                    <tt-card class="col-xs-12 p-5" ttHeading="orderinfo" ttTranslate>
                        <ng-container *ngTemplateOutlet="orderInfo"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="40">
                    <tt-card class="col-xs-12 p-5" ttHeading="this" ttTranslate>
                        <tt-button-goto [ttText]="'orderlinestatus_rfidconnect_this'" [ttGoto]="'rfidconnect'" [ttGotoParms]="{ argtype: 'poh_keyno_top', argvalue: pohKeynoTop }"></tt-button-goto>
                    </tt-card>

                    <tt-list class="col-xs-12 p-5" [ttData]="itemsListPohTops"></tt-list>
                </tt-divider-pane>

                <tt-divider-pane ttSize="40">
                    <tt-card class="col-xs-12 p-5" ttHeading="orderlines" ttTranslate>
                        <tt-button-goto [ttText]="'orderlinestatus_rfidconnect'" [ttGoto]="'rfidconnect'" [ttGotoParms]="{ argtype: 'order_internal_no', argvalue: menu.order_internal_no }"></tt-button-goto>
                    </tt-card>

                    <tt-list class="col-xs-12 p-5" [ttData]="itemsListStatuses"></tt-list>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #orderInfo>
    <ng-container *ngIf="!!menu">
        <tt-input ttLabel="order_internal_no" [ttModel]="menu.order_internal_no" ttReadonly></tt-input>
        <tt-input ttLabel="order_order_no" [ttModel]="menu.order_order_no" ttReadonly></tt-input>
        <tt-input ttLabel="custname" [ttModel]="menu.custname" ttReadonly></tt-input>
        <tt-date ttLabel="deliverydate_confirmed" [ttModel]="menu.deliverydate_confirmed" ttReadonly></tt-date>
    </ng-container>
</ng-template>
